export default __webpack_public_path__ + "static/media/template_business-man__0011_16---WangQiang.16ac8f96.png";